export default __webpack_public_path__ + "static/media/vox-img-legacy-010.94236fc4.jpg";